import React, { Component } from 'react';

import Cleave from '../../../components/UI/CustomInputField/CustomCleaveField';
import WidgetPropTypes from '../types';

export const WIDGET_NAME = 'set_parent_phone_number';
const VALID_PHONE_NUMBER_LENGTH = 10;

class ParentPhoneNumber extends Component {
  state = {
    phoneNumber: ''
  };

  onChange = value => {
    this.setState({ phoneNumber: value });
  };

  componentDidMount() {
    this.props.analytics.trackEvent('Registration Invite Parent Viewed');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.props.shouldEnable(
        WIDGET_NAME,
        this.state.phoneNumber.length === VALID_PHONE_NUMBER_LENGTH
      );
    }
  }

  render() {
    const { changeAnswerValue, widget, user, toggles } = this.props;

    const deRiskButtonText =
      toggles?.growthRegistrationFlowFields?.variables
        ?.parent_screen_de_risk_button;
    const teenText =
      user.userIsTeen && deRiskButtonText && user?.referralRewardValue
        ? deRiskButtonText
        : '';

    return (
      <div>
        <Cleave
          id="parent-phone-number"
          placeholder="Parent's phone number"
          onClick={this.props.onClick}
          options={{
            delimiters: ['(', ')', ' ', '-'],
            blocks: [0, 3, 0, 3, 4],
            numericOnly: true,
            phoneRegionCode: 'US'
          }}
          value={this.state.phoneNumber || ''}
          rawValue={true}
          onChange={value => {
            changeAnswerValue(widget, value);
            this.onChange(value);
          }}
          inputMode="numeric"
          pattern="[0-9]*"
          data-e2e="parent-phone"
          secondaryFormat={teenText}
        />
      </div>
    );
  }
}

ParentPhoneNumber.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default ParentPhoneNumber;
